import masterpayerService from '@/services/masterpayer.service.js'

export default {
  submitMasterpayer: (context, data) => {
    context.commit('setSubmittingMasterpayer', true)

    masterpayerService.masterpayerSubmit(data, (err, res) => {
      console.log('callback')
      if (err) {
        // show error
        context.commit('setSnackbar',
          {
            show: true,
            type: 'error',
            timeout: 10000,
            message: 'An error has occured while submitting your registration. Please contact administrator'
          },
          { root: true }
        )
      }

      context.commit('setSnackbar',
        {
          show: true,
          type: 'success',
          timeout: 10000,
          message: 'Your request has been successfully submitted'
        },
        { root: true }
      )

      context.commit('setSubmittingMasterpayer', false)
      context.commit('clearRequest')
    })
  },
  getAllMyMasterpayerRequest: context => {
    console.log('getting all mP')
    context.commit('setMasterpayerListLoading', true)
    masterpayerService.getAllMyMasterpayerRequest( vm.$store.state.currentUser.requestor_id, (err,res) => {
      if(err){
        context.commit('setSnackbar',
          {
            show: true,
            type: 'error',
            timeout: 20000,
            message: err.message
          },
          { root: true }
        )
      } else {
        context.commit('setMasterpayerRequest', res)
      }
      context.commit('setMasterpayerListLoading', false)
    })
  },
}
